import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';
import {
    useNavigate
} from "react-router-dom";
import DataObjectIcon from '@mui/icons-material/DataObject';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function Candidates() {
    const navigate = useNavigate();

    function handleSelectMaterial(serialNumber) {
        navigate('/materials/details/' + serialNumber);
    };

    const candidateMaterials = useSelector(state => state?.candidateMaterials);

    return (
        < React.Fragment >
            <div style={{ width: '100%' }}>
                <TableContainer component={Paper} >
                    <Accordion
                        defaultExpanded={true}
                    >
                        <AccordionSummary
                            style={{
                                backgroundColor: "#6b469e",
                                color: "white",
                                height: '3vh'
                            }}
                            sx={{
                                "&.Mui-expanded": {
                                    minHeight: 0
                                },
                                "&.MuiAccordionSummary-root": {
                                    minHeight: 0
                                },
                            }}
                            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
                        >
                            <Typography
                                style={{
                                    width: '100%'
                                }}
                            >
                                <DataObjectIcon style={{ marginRight: '1%', verticalAlign: "middle" }} />
                                Candidate Materials
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Table sx={{ minWidth: '30%' }} size="small" aria-label="client table">
                                <TableBody>
                                    {candidateMaterials?.map((candidate, i) => {
                                        return (
                                            <TableRow
                                                hover
                                                style={{
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => handleSelectMaterial(candidate?.serial_number)}
                                            >
                                                <TableCell
                                                    key={candidate?.serial_number + i + " valuecell"}

                                                >
                                                    {candidate?.serial_number}
                                                </TableCell>
                                            </TableRow>

                                        )

                                    })}
                                </TableBody>
                            </Table>
                        </AccordionDetails>
                    </Accordion>
                </TableContainer>
            </div>
        </React.Fragment >
    );
}